import { Component, OnInit } from '@angular/core';
import { ErrorCms } from '../../interfaces/error-cms.interface';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'lmw-error-forbidden',
  templateUrl: './forbidden.component.html'
})
export class ForbiddenComponent implements OnInit {

  public errorCms: ErrorCms;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.errorCms = this.route.snapshot.data.cmsData;
  }

}
